import { Link, styled } from '@mui/material/';
import SelectorsList from '../../../selectors-list/SelectorsList';

export const activeCountStyles = theme => ({
  color: theme.palette.primary.dark,
  cursor: 'default',
  fontSize: 13,
});

export const borderStyles = theme => ({
  border: `1px solid ${theme.palette.graphic.light}`,
});

export const boxStylesStyles = theme => ({
  '& > span': {
    padding: 0,
  },
  alignItems: 'center',
  borderRadius: 0.5,
  cursor: '',
  display: 'flex',
  height: 20,
  justifyContent: 'center',
  marginRight: theme.spacing(1),
  p: 0.5,
  width: 25,
});

export const chevronRightStyles = theme => ({
  color: theme.palette.secondary.main,
  justifySelf: 'end',
  size: 24,
});

export const chipStylesStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.secondary.light,
  borderRadius: 0.5,
  color: theme.palette.text.primary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  marginRight: theme.spacing(1),
  transition: [
    ['background', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
    ['box-shadow', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
  ],
  width: 25,
});

export const chipStylesSelectedStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 0.5,
  color: theme.palette.text.primary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  marginRight: theme.spacing(1),
  width: 25,
});

export const flexRowStyles = {
  alignItems: 'flex-end',
  display: 'flex',
};

export const inactiveCountStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  border: `1px solid ${theme.palette.graphic.light}`,
  borderRadius: 0.5,
  color: theme.palette.text.secondary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  marginRight: theme.spacing(1),
  width: 25,
});

export const inactiveCountSelectedStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  border: `1px solid ${theme.palette.graphic.light}`,
  borderRadius: 0.5,
  color: theme.palette.text.secondary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  marginRight: theme.spacing(1),
  width: 25,
});

export const labelStyles = theme => ({
  ...theme.typography.body2,
});

export const linkStyles = theme => ({
  '&:hover': {
    '& $chipStyles': {
      backgroundColor: theme.palette.primary.light,
    },
    '& $inactiveCount': {
      backgroundColor: theme.palette.secondary.light,
    },
    backgroundColor: theme.palette.secondary.light,
  },
  borderBottom: `1px solid ${theme.palette.surface.swimlane}`,
  display: 'grid',
  gridGap: theme.spacing(1),
  gridTemplateColumns: '100%',
  padding: theme.spacing(2),
  textDecoration: 'none',
  width: '100%',
});

export const listStyles = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};

export const ListItemHeaderContainerStyles = styled(Link)({
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'space-between',
});

export const selectedListItemStyles = theme => ({
  backgroundColor: theme.palette.secondary.light,
});

export const spaceBetweenStyles = {
  justifyContent: 'space-between',
};

export const titleStyles = theme => ({
  color: theme.palette.primary.dark,
  flex: '0 0 240px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('lg')]: {
    flex: 'none',
  },
});

export const SelectorsListStyled = styled(SelectorsList)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  height: '100%',
  overflowY: 'scroll',
  padding: theme.spacing(0, 0, 4.5),
  scrollbarWidth: 'none',
}));
